import { requestContext } from "@/stores/common/request-context";

// Only set __webpack_public_path__ in standalone mode. In the Procore host, the
// loaded remoteEntry.js already points at the build it came from, while
// window.LC_CDN comes from the zone's env-config.js and points at that zone's
// deployed build. Overriding would send lazy chunks of a preview or local
// override build to a CDN that doesn't have them.
//
// IMPORTANT: This must be a plain JS file, not CoffeeScript.
// CoffeeScript wraps code in an IIFE which creates a local variable instead of
// assigning to webpack's global __webpack_public_path__.
if (window.LC_CDN && !requestContext.usingProcoreHostApp) {
  __webpack_public_path__ = window.LC_CDN;
}
